module.exports = __webpack_public_path__ + "static/media/IMG_7735.2389be22.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/IMG_7735.png
// module id = 41
// module chunks = 0